import { IShimmeredDetailsListProps, ShimmeredDetailsList } from '@fluentui/react';
import * as React from 'react';

const DetailsListShimmer: React.FC<IShimmeredDetailsListProps> = (props) => {
  return <ShimmeredDetailsList {...props} />;
};

export default DetailsListShimmer;
